import {
  NoTaxNumberReasonCategory,
  NoTaxNumberReasonCode,
} from '@/types/api/tax-info';

export const FOREIGN_NO_TAX_NUMBER_REASON_OTHER_MAX_LENGTH = 80;

export const FOREIGN_NO_TAX_NUMBER_REASON_CATEGORY_CODES = [
  NoTaxNumberReasonCategory.COUNTRY_DOES_NOT_ISSUE_TIN,
  NoTaxNumberReasonCategory.UNABLE_TO_PROVIDE_NOW,
  NoTaxNumberReasonCategory.NOT_LEGALLY_REQUIRED,
] as const;

export const NO_TAX_NUMBER_REASON_CODE_TO_CATEGORY: Record<
  NoTaxNumberReasonCode,
  NoTaxNumberReasonCategory
> = {
  [NoTaxNumberReasonCode.COUNTRY_DOES_NOT_ISSUE_TIN]:
    NoTaxNumberReasonCategory.COUNTRY_DOES_NOT_ISSUE_TIN,
  [NoTaxNumberReasonCode.NEW_RESIDENT_NO_TIN_YET]:
    NoTaxNumberReasonCategory.UNABLE_TO_PROVIDE_NOW,
  [NoTaxNumberReasonCode.OTHER_UNABLE_TO_PROVIDE]:
    NoTaxNumberReasonCategory.UNABLE_TO_PROVIDE_NOW,
  [NoTaxNumberReasonCode.INCOME_BELOW_THRESHOLD]:
    NoTaxNumberReasonCategory.NOT_LEGALLY_REQUIRED,
  [NoTaxNumberReasonCode.NOT_REQUIRED_TO_FILE_RETURNS]:
    NoTaxNumberReasonCategory.NOT_LEGALLY_REQUIRED,
  [NoTaxNumberReasonCode.RETIRED]:
    NoTaxNumberReasonCategory.NOT_LEGALLY_REQUIRED,
  [NoTaxNumberReasonCode.NO_TAXABLE_INCOME]:
    NoTaxNumberReasonCategory.NOT_LEGALLY_REQUIRED,
  [NoTaxNumberReasonCode.MINOR_OR_DEPENDENT]:
    NoTaxNumberReasonCategory.NOT_LEGALLY_REQUIRED,
  [NoTaxNumberReasonCode.TIN_ONLY_FOR_SPECIFIC_CATEGORIES]:
    NoTaxNumberReasonCategory.NOT_LEGALLY_REQUIRED,
  [NoTaxNumberReasonCode.LEGAL_EXEMPTION]:
    NoTaxNumberReasonCategory.NOT_LEGALLY_REQUIRED,
};

export const UNABLE_TO_PROVIDE_NOW_REASON_CODES = [
  NoTaxNumberReasonCode.NEW_RESIDENT_NO_TIN_YET,
  NoTaxNumberReasonCode.OTHER_UNABLE_TO_PROVIDE,
] as const;

export const NOT_LEGALLY_REQUIRED_REASON_CODES = [
  NoTaxNumberReasonCode.INCOME_BELOW_THRESHOLD,
  NoTaxNumberReasonCode.NOT_REQUIRED_TO_FILE_RETURNS,
  NoTaxNumberReasonCode.RETIRED,
  NoTaxNumberReasonCode.NO_TAXABLE_INCOME,
  NoTaxNumberReasonCode.MINOR_OR_DEPENDENT,
  NoTaxNumberReasonCode.TIN_ONLY_FOR_SPECIFIC_CATEGORIES,
  NoTaxNumberReasonCode.LEGAL_EXEMPTION,
] as const;

export const NO_TAX_NUMBER_REASON_CODE_OPTIONS = [
  ...UNABLE_TO_PROVIDE_NOW_REASON_CODES,
  ...NOT_LEGALLY_REQUIRED_REASON_CODES,
  NoTaxNumberReasonCode.COUNTRY_DOES_NOT_ISSUE_TIN,
] as const;
